import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { getAirportLabel } from 'component/Search/Airport/__helper/airport';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';

import { Iata } from 'types/Search/airport';

export const useSaveLastAirports = () => {
    const { t } = useTranslation();
    const { react } = useContext(CommunicationContext);

    return useCallback(
        (airportValue: Set<Iata>) => {
            const airportList = [...airportValue];
            const label = airportList.length
                ? t(getAirportLabel(airportList[0]))
                : '';

            react.dispatch('save-last-airports', {
                value: airportList.join(','),
                airportName: label,
            });
        },
        [react, t]
    );
};
